// extracted by mini-css-extract-plugin
export default {"alert":"styles_alert__8kEQ+","header":"styles_header__8F58A","wrap":"styles_wrap__uXzxZ","block":"styles_block__dxs96","title":"styles_title__1xMVl"};